import { Filters } from '../../_flux/constants/filter/filters';

export const CHECK_ORDER = [
    Filters.VEHICLE_STATE,
    Filters.REGISTRATION,
];
